import React from 'react';
import PropTypes from 'prop-types';

import {CircularProgress} from "@mui/material";

import Badge from "components/Badge";

import {black500, greyishBlue500, blueColor} from "assets/jss/main";

StatusTab.propTypes = {
    label: PropTypes.node,
    count: PropTypes.number,
    theme: PropTypes.string,
    badgeTextColor: PropTypes.string,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    loading: PropTypes.bool
};

function StatusTab({label, count = 0, theme, badgeTextColor, selected = false, onClick, loading = false}) {
    return (
        <div
            onClick={onClick}
            style={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                height: '32px',
                padding: '6px 12px',
                borderRadius: '8px',
                cursor: 'pointer',
                userSelect: 'none'
            }}
        >
            <span style={{
                fontSize: '16px',
                fontWeight: selected ? 600 : 400,
                color: selected ? black500 : greyishBlue500,
                whiteSpace: 'nowrap'
            }}>
                {label}
            </span>

            <Badge
                color={theme}
                labelColor={badgeTextColor ?? theme}
            >
                {loading ? <CircularProgress size={10} color={'inherit'} /> : count}
            </Badge>

            {selected && (
                <span style={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: '-1px',
                    height: '2px',
                    borderTopLeftRadius: '8px',
                    borderTopRightRadius: '8px',
                    backgroundColor: blueColor
                }} />
            )}
        </div>
    );
}

export default StatusTab;
